import { DialogService } from "./../../../../../core/src/lib/services/dialog.service";
import { ReportService } from "./../../../../../../apps/resource-portal/src/app/services/report.service";
import { FolderExplorerComponent } from "./../folder-explorer/folder-explorer.component";
import { AttachmentService } from "../../../../../../apps/resource-portal/src/app/services/attachment.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ProjectService } from "../../../../../../apps/resource-portal/src/app/services/project.service";
import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EMPTY_GUID } from "apps/resource-portal/src/app/constants/app.constant";
import { RoomService } from "apps/resource-portal/src/app/services/room.service";
import { CommonUtils } from "libs/core/src/lib/utils/common.utils";
import { Subject, takeUntil } from "rxjs";
import { apiconstants } from "apps/resource-portal/src/app/constants/api.constant";
import { PrivilegeService } from "apps/resource-portal/src/app/services/privilege.service";

@Component({
  selector: "concourse-notes-report",
  templateUrl: "./notes-meeting-report.component.html",
  styleUrls: ["./notes-meeting-report.component.scss"],
})
export class NotesMeetingReportComponent
  implements OnInit, OnDestroy, OnChanges
{
  projects = [];
  departments = [];
  reportItems = [];
  activeIds = [];
  rooms = [];
  url = null;
  showLoading = false;
  @Input("type") type = 1;
  @ViewChild("pdfViewer") public pdfViewer;

  @Input() selectedDepartment = null;
  @Input() selectedRoom = null;
  @Input() saveToFolder = false;
  @Input() projectId = null;
  @Input() reportType;
  @Input() isRoomTypical;

  $unsubscribe = new Subject<void>();
  commonUtils = CommonUtils;
  emptyGuid = EMPTY_GUID;

  constructor(
    public _projectService: ProjectService,
    private activateRoute: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private _roomService: RoomService,
    private router: Router,
    // private http: HttpClient,
    private _attachmentService: AttachmentService,
    private _modalService: NgbModal,
    private _reportService: ReportService,
    private _dialogService: DialogService,
    private privilegeService: PrivilegeService
  ) {}

  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe((result) => {
      if (result && result["projectId"]) {
        this.projectId = result["projectId"];
        this.getAllProjects();
      } else {
        this.router.navigate(["/projects"]);
      }
    });
  }

  ngOnChanges(): void {
    this.getRequests(this.selectedRoom);
  }

  getAllProjects() {
    this._projectService
      .getAllProjects()
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((res: any) => {
        this.projects = res.data || [];
        this.projects = CommonUtils.sortByKey(this.projects, "projectname");
        if (this.projects.length) {
          if (!this.projectId) {
            this.projectId = this.projects[0].id;
          }
          this.getAllDepartments(this.projectId);
        } else {
          this.projectId = null;
        }
      });
  }

  getAllDepartments(projectId: string) {
    if (this.projectId == EMPTY_GUID) {
      this.selectedDepartment = EMPTY_GUID;
      this.selectedRoom = EMPTY_GUID;
    }
    this._roomService
      .getDepartmentByProjectId(projectId, this.isRoomTypical)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.departments = result || [];
          this.departments = CommonUtils.sortByKey(
            this.departments,
            "departmentname"
          );
          if (this.departments.length) {
            if (!this.selectedDepartment) {
              this.selectedDepartment = this.departments[0].id;
            }
            this.getAllRooms(this.selectedDepartment);
          } else {
            this.selectedDepartment = null;
          }
        }
      });
  }

  getAllRooms(departmentId: string) {
    this.selectedDepartment = departmentId;
    if (this.selectedDepartment == EMPTY_GUID) {
      this.selectedRoom = EMPTY_GUID;
      this.getRequests(this.selectedRoom);
    }
    this._roomService
      .getRoomsByDepartmentId(departmentId, this.isRoomTypical)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.rooms = result || [];
          this.rooms = CommonUtils.sortByKey(this.rooms, "name");
          if (this.rooms.length) {
            // if (!this.selectedRoom) {
            //   this.selectedRoom = EMPTY_GUID;
            // }
            if (!this.selectedRoom) {
              this.selectedRoom = this.rooms[0].id;
            }
            this.getRequests(this.selectedRoom);
          } else {
            this.selectedRoom = null;
          }
        }
      });
  }

  getRequests(roomId: string) {
    this.url = null;
    this.selectedRoom = roomId;
    this.showLoading = true;
    this.getNotesReports();
  }

  getNotesReports() {
    let url =
      apiconstants.API_APPOROVAL_REQUEST_REPORT +
      `?project=${this.projectId}&department=${this.selectedDepartment}&room=${this.selectedRoom}&type=${this.type}`;
    this._attachmentService
      .getBlobFromURL(url)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe(
        (res) => {
          if (res) {
            this.url = URL.createObjectURL(res);
          }
        },
        (err) => {
          console.log("Error occured, Retrying! ", err);
          this.getNotesReports();
        }
      );
  }
  downloadNoteReport() {
    this._attachmentService.downloadFileFromUrl(
      this.url,
      "note_report" + new Date().toLocaleTimeString(),
      true
    );
  }

  pageRendered(e: CustomEvent) {
    console.log("(page-rendered)", e);
    this.showLoading = false;
  }

  openFolderExplorer() {
    const modalRef = this._modalService.open(FolderExplorerComponent, {
      centered: true,
      size: "xl",
      windowClass: "modal-class",
      backdrop: "static",
    });
    modalRef.componentInstance.projectId = this.projectId;
    let dept = this.departments.length
      ? this.departments.find((d) => d.id === this.selectedDepartment)
          .departmentname
      : "";
    if (dept) {
      modalRef.componentInstance.reportName = this.reportType + " - " + dept;
    } else {
      modalRef.componentInstance.reportName = this.reportType;
    }
    modalRef.result.then((data: any) => {
      if (data) {
        this._attachmentService
          .returnBlob(
            this.url,
            "note_report" + new Date().toLocaleTimeString(),
            true
          )
          .then((res: any) => {
            let formData = new FormData();
            formData.append("folder", data.folderId);
            formData.append("reportname", data?.reportName || "");
            formData.append("project", this.projectId);
            formData.append("file", res);
            this._reportService
              .saveReportToFolder(formData)
              .pipe(takeUntil(this.$unsubscribe))
              .subscribe((result) => {
                if (result && result.status == 200) {
                  this._dialogService.showToast(
                    "Report Uploaded to Folder",
                    "success"
                  );
                }
              });
          });
      }
    });
  }

  ngOnDestroy() {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
  hasAccess(role: string): boolean {
    return this.privilegeService.userProjectAccess(role, this.projectId);
  }
}
